import Vue from 'vue'
import Vuex from 'vuex'
import { offer } from '@/store/modules/offer/index'
import { offerPlugin } from '@/store/modules/offer/plugins'
import { roles } from '@/store/modules/roles/index'
import { alerts } from '@/store/modules/alerts/index'
import { rateModel } from '@/store/modules/rateModel/index'
import { process } from '@/store/modules/process/index'

Vue.use(Vuex)

/**
 * Create store function
 */
export const createStore = () => ({
  modules: {
    roles,
    offer,
    alerts,
    rateModel,
    process,
  },
  plugins: [offerPlugin],
})

export default new Vuex.Store(createStore())
